/**
 * The OKLCH-hue wheel: the sRGB hue circle re-spaced so equal angles are equal
 * OKLab hue steps. Targets still carry the base's HSV saturation and value, so
 * it behaves like RYB (a different spacing), not like a different colour space.
 *
 * The raw OKLab hue of the pure-hue circle reverses by 0.16° across HSV
 * 231.4°–240° — invisible on the ring, a 13° inverse error if left alone
 * (research 05 §7). `normalizeWarpTable` monotonises it and the tests pin the
 * result.
 *
 * The table is DATA, generated by `scripts/build-oklch-hue-table.ts` and
 * committed: deriving it here meant 72 `hsvToHex` + `hexToOklch` round trips
 * on every module load, in every bundle that touched a colour wheel.
 * `scripts/lib/oklch-hue-table.test.ts` re-runs the derivation and compares,
 * so the JSON cannot drift from the maths that produced it.
 *
 * @module services/dye/wheels/oklch-hue
 */
import oklchHueData from '../../../data/oklch-hue-table.json' with { type: 'json' };
import { hueWarpWheel } from './hue-warp.js';
export const OKLCH_HUE_TABLE = oklchHueData.table;
export const OKLCH_HUE_WHEEL = hueWarpWheel('oklch-hue', OKLCH_HUE_TABLE);
//# sourceMappingURL=oklch-hue.js.map